import * as React from "react";
import { Icon } from "../actions/Icon";

/**
 * Upload-while-recording progress. Reassures that the file is safe locally and the link will be ready on stop.
 * FR-RD7: capture writes to local disk first, so every state leads with where the file is saved.
 */
export interface UploadStatusProps {
  state?: "uploading" | "done" | "offline";
  /** 0–1 */
  progress?: number;
  label?: React.ReactNode;
  /** No pill background (inline footers) */
  plain?: boolean;
  className?: string;
}

export function UploadStatus({ state = "uploading", progress = 0, label, plain, className }: UploadStatusProps): JSX.Element {
  const icon = state === "offline" ? "cloud-slash" : state === "done" ? "cloud-check" : "cloud-arrow-up";
  const text =
    label ||
    (state === "offline"
      ? "Saved on this device · will upload when you reconnect"
      : state === "done"
        ? "Uploaded"
        : "Saved locally · " + Math.round(progress * 100) + "% uploaded");
  const cls = ["gk-upload", state === "offline" && "gk-upload--offline", plain && "gk-upload--plain", className]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={cls} role="status">
      <Icon name={icon} size={plain ? 16 : 18} />
      {text}
      {state === "uploading" && !plain && (
        <span className="gk-upload__bar">
          <span className="gk-upload__fill" style={{ display: "block", width: progress * 100 + "%" }} />
        </span>
      )}
    </span>
  );
}
